import React from "react";
import { Link } from "react-router-dom";
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs.js";

export default function Patients() {
  return (
    <section className="contacts patients">
      <Breadcrumbs />
      <h1 className="contacts__title history__title">Пациентам</h1>

      <div>
        <div>
          <h3 className="about-nii__title antiCorruption__title">
            Директор ГБУ СО "УрНИИДВиИ" профессор, д.м.н. Кунгуров Николай
            Васильевич
          </h3>
          <p className="dissertation__text">
            Прием граждан: вторая, четвертая неделя месяца (среда с 9:00 -
            11:00)
          </p>
          <p className="dissertation__text">
            Тел. приемной +7 (343) 218-33-71<br></br>e-mail:
            n.kungurov@gmail.com
          </p>
        </div>

        <div>
          <h3 className="about-nii__title antiCorruption__title">
            Заместитель директора по научной работе ГБУ СО "УрНИИДВиИ"
            профессор, д.м.н. Зильберберг Наталья Владимировна
          </h3>
          <p className="dissertation__text">
            Прием граждан: вторая, четвертая неделя месяца (понедельник, среда
            9:00 - 11:00)
          </p>
          <p className="dissertation__text">
            Тел. +7 (343) 218-95-70<br></br>e-mail: nauka-urnii@mail.ru
          </p>
        </div>

        <div>
          <h3 className="about-nii__title antiCorruption__title">
            Зав. клиникой, к.м.н. Гришаева Елена Владимировна
          </h3>
          <p className="dissertation__text">
            Прием граждан: еженедельно (среда 10:00 - 12:00)
          </p>
          <p className="dissertation__text">
            Тел. +7 (343) 218-33-70<br></br>e-mail: egrishaeva@yandex.ru
          </p>
        </div>
      </div>

      <div className="footer__middle_block">
        <Link to="/patients/reception" className="footer__link">
          Прием специалистов
        </Link>
        <Link to="/patients/reception-omc" className="footer__link">
          Прием специалистов ОМС
        </Link>
        <Link to="/patients/working" className="footer__link">
          График работы
        </Link>
        <Link to="/patients/pay" className="footer__link">
          Платные медицинские услуги
        </Link>
        <Link to="/patients/price-list" className="footer__link">
          Прейскурант
        </Link>
        <Link to="/patients/specialists" className="footer__link">
          Специалисты
        </Link>
        <Link to="/patients/services" className="footer__link">
          Оказание услуг гражданам в сфере здравоохранения
        </Link>
        <Link to="/patients/participantsSVO" className="footer__link">
          Участникам СВО
        </Link>
        <Link to="/patients/accessible-environment" className="footer__link">
          Доступная среда
        </Link>
        <Link to="/patients/helplines" className="footer__link">
          Телефоны доверия
        </Link>
        <Link to="/patients/fire-safety" className="footer__link">
          Пожарная безопасность
        </Link>
        <Link to="/patients/clinical-examination" className="footer__link">
          Диспансеризация населения
        </Link>
        <Link to="/patients/week" className="footer__link">
          Мероприятия по профилактике заболеваний и поддержке здорового образа
          жизни
        </Link>
        <Link to="/patients/gosuslugi" className="footer__link">
          Госуслуги
        </Link>
        <Link to="/patients/question-answer" className="footer__link">
          Вопрос–ответ
        </Link>
      </div>
    </section>
  );
}
